import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PurchaseOrder, PurchaseOrderPatch, PurchaseOrderShipment, PurchaseOrderStatus } from '../purchase-orders.service';

export const PurchaseOrderActions = createActionGroup({
	source: 'Purchase Order Spotlight',
	events: {
		'Get Purchase Order': props<{ purchaseOrderIdentifier: string }>(),
		'Get Purchase Order Success': props<{ purchaseOrder: PurchaseOrder }>(),
		'Get Purchase Order Error': props<{ error: string }>(),
		'Email Purchase Order': props<{ purchaseOrderIdentifier: string, recipients: string[] }>(),
		'Email Purchase Order Success': emptyProps(),
		'Email Purchase Order Error': props<{ error: string }>(),
		'Reopen Purchase Order': props<{ purchaseOrderIdentifier: string }>(),
		'Reopen Purchase Order Success': props<{ purchaseOrder: PurchaseOrder }>(),
		'Reopen Purchase Order Error': props<{ error: string }>(),
		'Close Purchase Order': props<{ purchaseOrderIdentifier: string }>(),
		'Close Purchase Order Success': props<{ purchaseOrder: PurchaseOrder }>(),
		'Close Purchase Order Error': props<{ error: string }>(),
		'Clear Purchase Order': emptyProps(),
		'Set Purchase Order Status': props<{ status: PurchaseOrderStatus, closedDate: string }>(),
		'Add Purchase Order Shipment': props<{ shipment: PurchaseOrderShipment }>(),
		'Update Purchase Order Shipment': props<{ shipment: PurchaseOrderShipment }>(),
		'Update Purchase Order': props<{ purchaseOrderIdentifier: string, patch: Partial<PurchaseOrderPatch> }>(),
		'Update Purchase Order Success': props<{ purchaseOrder: PurchaseOrder }>(),
		'Update Purchase Order Error': props<{ error: string }>()
	}
});
